import {
  Component,
  OnInit,
  OnDestroy,
  Input,
  ChangeDetectorRef,
  ChangeDetectionStrategy,
} from "@angular/core";
import { RenderedService } from "../../rendered.service";
import { BaseScaffoldComponent } from "../base-scaffold/base-scaffold.component";
import { CourseService } from "../../../../services/course.service";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";

@Component({
  selector: "scaffold-data",
  templateUrl: "./scaffold-data.component.html",
  styleUrls: [
    "../../rendered.component.scss",
    "./scaffold-data.component.scss",
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ScaffoldDataComponent
  extends BaseScaffoldComponent
  implements OnInit, OnDestroy
{
  public destroy$: Subject<boolean> = new Subject<boolean>();
  listUrl;
  constructor(
    public cdr: ChangeDetectorRef,
    public renderedService: RenderedService,
    private courseService: CourseService
  ) {
    super(cdr, renderedService);
  }

  ngOnInit() {
    this.renderedService
      .listenForUpdates()
      .pipe(takeUntil(this.destroy$))
      .subscribe((trigger) => {
        this.cdr.detectChanges();
      });
    this.getDataComponenet();
  }

  ngOnDestroy() {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }

  getDataComponenet() {
    console.log(this.item);
    if (this.item.content) {
      this.item.view = this.item.content;
    } else {
      if (this.item.toload_id || this.item.value) {
        let toload = this.value;
        /*this.itemsService.registerData("courses", this.courseService.id, this.item.value ? this.item.name : 'toload_id').subscribe(toload => {
          this.listUrl = this.item.toload_type + "/" + toload + "?mode=" + (this.item.toload_mode || "read");
          console.log(this.listUrl);
        this.courseService.get(this.listUrl).subscribe(co => this.item.view = co);
        this.detectChanges();
       })*/
        this.listUrl =
          this.item.toload_type +
          "/" +
          (this.item.value || this.item.toload_id) +
          "?mode=" +
          (this.item.toload_mode || "read");
        console.log(this.listUrl);
        this.courseService.get(this.listUrl).subscribe((co) => {
          this.item.view = co; //this.triggerUpdate("data view load");
          this.redraw();
        });
      }
    }
  }

  update() {
    console.log("UPDATE DATA");
    this.getDataComponenet();
  }
}
